
    import { defineComponent, computed, unref } from 'vue';
    import { useState } from 'vuex-composition-helpers';
    import { IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
    import AttributesHotelFilter from '@ve/components/filters/common/components/attributesHotelFilter/AttributesHotelFilter.vue';
    import FilterPostWrapper from '@ve/components/searchFilters/filterList/desktop/FilterPostWrapper.vue';
    import useFilterAttributesHotel from '@ve/components/filters/common/use/useFilterAttributesHotel';
    import useFilterAttributesAnalytics from '@ve/components/filters/common/use/useFilterAttributesAnalytics';
    import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
    import ServiceChildFilterAttributesMethods from './ServiceChildFilterAttributesMethods';

    export default defineComponent({
        name: 'ServiceChildFilter',
        components: {
            AttributesHotelFilter,
            FilterPostWrapper,
        },
        setup() {
            const { touristGroup } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['touristGroup']);
            const isUserAddToSearchChildren = computed(() => unref(touristGroup).infants || unref(touristGroup).kids);

            return {
                ServiceChildFilterAttributesMethods,
                isUserAddToSearchChildren,
                ...useFilterAttributesHotel('childFilter'),
                ...useFilterAttributesAnalytics(ServiceChildFilterAttributesMethods),
            };
        },
    });
